import { render, staticRenderFns } from "./toptab.vue?vue&type=template&id=4a04ce92&scoped=true&"
import script from "./toptab.vue?vue&type=script&lang=js&"
export * from "./toptab.vue?vue&type=script&lang=js&"
import style0 from "./toptab.vue?vue&type=style&index=0&id=4a04ce92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a04ce92",
  null
  
)

export default component.exports